import { Box, CardActions, CardContent } from "@mui/material";
import React from "react";
import { EnquiryLabels } from "../../../schemes/enquiries/enquiries_list";
import { useNavigate } from "react-router-dom";
import Loading from "../../../../components/loading/loading";
import dayjs from "dayjs";
import { SubmittedChoices } from "../../model/submitted_choices";
import {
  TableCell,
  TableEmptyState,
  TableFooterPagination,
  TableHeaderRow,
  TableRow,
} from "../../../users/components/table_toolkit/table_toolkit";

const ROWS_PER_PAGE_OPTIONS = [8, 25, 50, 100];

interface DataGridInterface {
  labels: EnquiryLabels[];
  data: SubmittedChoices[];
  count: number;
  page: number;
  setPage: (val: number) => void;
  pageSize: number;
  setPageSize: (val: number) => void;
  isLoading: boolean;
}

export default function DataGridChoicesResponses({
  labels,
  data,
  page,
  setPage,
  pageSize,
  setPageSize,
  count,
  isLoading,
}: DataGridInterface) {
  const navigate = useNavigate();
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const startRange = page * pageSize + 1;
  const endRange = Math.min((page + 1) * pageSize, count);
  const summaryText = `Showing ${count ? startRange : 0} to ${endRange || 0} of ${count || 0} entries`;

  return (
    <>
      <CardContent sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        {isLoading ? (
          <Box display="flex" justifyContent="center" py={8}>
            <Loading />
          </Box>
        ) : data?.length === 0 ? (
          <TableEmptyState
            message="No responses found"
            hint="Try adjusting your search or filters."
          />
        ) : (
          <Box mt={1}>
            <TableHeaderRow
              labels={labels.map((item) => ({ label: item.label }))}
              align="left"
              bordered
            />
            {data.map((item, index) => {
              const formattedDate = dayjs(item?.submittedOn)?.format?.("DD MMM YYYY");
              return (
                <TableRow
                  key={item.id}
                  bordered
                  onClick={() =>
                    navigate(`/choices/viewResponse/${item?.id}`, {
                      state: { id: item?.choiceId },
                    })
                  }
                >
                  <TableCell label="UID" bordered>{page * pageSize + index + 1}</TableCell>
                  <TableCell label="Full Name" bordered>{item?.name}</TableCell>
                  <TableCell label="Survey name" bordered>{item?.choiceName}</TableCell>
                  <TableCell label="Contact Number" bordered>{item?.mobileNumber}</TableCell>
                  <TableCell label="State" bordered>{item?.state}</TableCell>
                  <TableCell label="District" bordered>{item?.district}</TableCell>
                  <TableCell label="Education" bordered>{item?.education}</TableCell>
                  <TableCell label="Occupation" bordered>{item?.occupation}</TableCell>
                  <TableCell label="Submitted On" bordered isLast>{formattedDate}</TableCell>
                </TableRow>
              );
            })}
          </Box>
        )}
      </CardContent>
      {data?.length > 0 && (
        <CardActions sx={{ px: 3, pb: 3 }}>
          <Box width="100%">
            <TableFooterPagination
              count={count}
              page={page}
              onPageChange={handleChangePage}
              summaryText={summaryText}
              rowsPerPage={pageSize}
              rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
              onRowsPerPageChange={(newSize) => {
                setPageSize(newSize);
                setPage(0);
              }}
            />
          </Box>
        </CardActions>
      )}
    </>
  );
}
